import SliderViewSection from "../../components/SliderViewSection";
import { Contractor1,
  
  Transport1,
  Transport2,
  Transport3,
  Transport4,
  Transport5,
  Transport6,

   } from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import FourCardsSwap from "../../components/FourCardSwapSection";
import FuelManagementLanding from "../../components/Solution/FuelManagementLanding";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import SeemlessOperations from "../../components/Solution/SeemlessOperations";
import TogetherSection from "../../components/Solution/TogetherChange";
import { Subtitles } from "@mui/icons-material";


const safetyAndSustainabilityData = [
  {
    title: "Intelligent Fleet Operations Platform.",
    para:
      "A unified transport management platform designed to monitor, manage and optimize fleet operations through AI, IoT and real-time connected technologies. Gain complete visibility across vehicles, drivers, fuel and operational performance.",
    mediaUrl: Transport1
  },
  {
    title: "Real-Time Vehicle Intelligence",
    para:
      "Seamlessly integrate with On-Board Units (OBU) to capture vehicle diagnostics, trip information, speed, engine health and operational parameters in real time.",
    mediaUrl: Transport2
  },
  {
    title: "Enhancing Driver Safety & Compliance",
    para:
      "Monitor driver behavior, fatigue, distraction and compliance using AI-powered Driver Monitoring Systems integrated into the transport ecosystem.",
    mediaUrl: Transport3
  },
  {
    title: "Intelligent Fuel Management",
    para:
      "Integrate fuel sensors and IoT devices to monitor fuel consumption, detect pilferage and optimize fleet fuel efficiency across operations.",
    mediaUrl: Transport4
  },
  {
    title: "Ensuring Safe & Authorized Operations ",
    para:
      "Enhance transport safety through integrated breathalyzer systems and automated driver authorization mechanisms before vehicle operations.",
    mediaUrl: Transport5
  },
  {
    title: "Connected Operations & Predictive Intelligence",
    para:
      "Leverage AI-powered analytics and centralized monitoring to improve fleet utilization, reduce operational risks and drive efficient transport management.",
    mediaUrl: Transport6
  },
];

const FourCardsSwapcardData = [
  {
    title: "AI / IoT / OBU Integration",
    description:
      "Enable seamless connectivity between vehicles, fuel systems, driver monitoring devices and operational platforms for unified fleet intelligence.",
  },
  {
    title: "Interactive Operational Dashboards",
    description:
      "Access live dashboards with trip status, fleet utilization, fuel trends, driver performance and operational KPIs from anywhere",
  },
  {
    title: "Centralized Data Management ",
    description:
      "Consolidate transport, fuel, driver and vehicle data into a single digital ecosystem for improved coordination and visibility.",
  },
  {
    title: "Secure & Scalable Architecture",
    description:
      "Built on a modular and cybersecurity-compliant architecture that scales seamlessly across enterprise transport operations.",
  },
];

const AnimatedCardCrausalData = [
  {
    title: "Real-Time Fleet Tracking ",
    description:
      "Track vehicle movement, trip status and route deviations across transport operations.",
  },
  {
    title: "Driver Behaviour Intelligence",
    description:
      "Monitor fatigue, distraction and unsafe driving patterns using AI-enabled monitoring systems.",
  },
  {
    title: "Fuel Usage Transparency",
    description: "Capture live fuel consumption data and detect abnormal fuel utilization trends.",
  },
  {
    title: "Automated Dispatch & Scheduling",
    description:
      "Digitize vehicle allocation, trip planning and transport scheduling workflows.",
  },
  {
    title: "Compliance & Safety Control ",
    description:
      "Enable breathalyzer validation, driver authorization and operational compliance checks.",
  },
  {
    title: "Predictive Performance Analytics",
    description:
      "Analyze operational data to improve fleet utilization, reduce downtime and optimize transport efficiency.",
  },
];

const tabsData = [
  {
    label: "About iED",
    key: "1",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "Mission",
    key: "2",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "Leadership",
    key: "3",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "Differentiators",
    key: "4",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "Technology",
    key: "5",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
];


export default function SolutionFuelManagement() {
  return (
    <>
      <FuelManagementLanding />

      <SliderViewSection
        title={"Smart Integrated Transport Management for Smarter Operations"}
        subTitle={"Our Integrated Transport Management System is designed to help enterprises monitor, optimize and secure fleet operations across industries such as mining, logistics, construction, ports and transportation. Powered by AI, IoT and connected vehicle technologies, the platform delivers real-time visibility into vehicle performance, driver safety, fuel consumption and operational efficiency."}
        data={safetyAndSustainabilityData}
      />
      {/* <CardSwapSectionComponent data={safetyAndSustainabilityData} /> */}
      <AnimatedCardCrausal
        title={"Advanced Capabilities for Intelligent Transport Operations"}
        subTitle={"Enhance fleet efficiency, operational coordination and transport safety through connected intelligence and smart digital controls."}
        data={AnimatedCardCrausalData}
      />
      <SeemlessOperations />
      <FourCardsSwap
        title={"State-of-the-Art Technology Powering Intelligent Transport Operations"}
        subTitle={"Our Integrated Transport Management System combines AI, IoT, OBU connectivity and advanced analytics to deliver real-time operational visibility, smarter fleet coordination and intelligent decision-making across transport ecosystems."}
        cardData={FourCardsSwapcardData}
      />

      <WeAreIED />
      <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
      <TogetherSection
        title={"Driving the Future of Connected Transport."}
        SubTitle={"Empowering enterprises with intelligent transport operations that improve fleet visibility, operational coordination and driver accountability across every movement."} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
